import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import LessonsPage from "@/pages/lessons/page";
import LessonPage from "@/pages/lesson/page";
import RhythmPage from "@/pages/rhythm/page";
import PlacementTestPage from "@/pages/placement-test/page";
import DiagnosticPage from "@/pages/diagnostic/page";
import AuthPage from "@/pages/auth/page";
import AdminPage from "@/pages/admin/page";
import RequireAuth from "@/components/auth/RequireAuth";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/entrar", element: <AuthPage mode="login" /> },
  { path: "/criar-conta", element: <AuthPage mode="register" /> },
  { path: "/aulas", element: <RequireAuth><LessonsPage /></RequireAuth> },
  { path: "/aulas/:id", element: <RequireAuth><LessonPage /></RequireAuth> },
  { path: "/ritmo", element: <RequireAuth><RhythmPage /></RequireAuth> },
  { path: "/teste-de-nivel", element: <RequireAuth><PlacementTestPage /></RequireAuth> },
  { path: "/diagnostico", element: <RequireAuth><DiagnosticPage /></RequireAuth> },
  { path: "/admin", element: <RequireAuth><AdminPage /></RequireAuth> },
  { path: "*", element: <NotFound /> },
];

export default routes;
